import './modal-task.css';
import { useEffect, useRef, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import projectBuckets from 'data/projectBuckets.json';
import { stateUpdateTaskModal, useTaskModalDispatch, useTaskModalState } from 'contexts/TaskModalContext';
import { stripTaskModalFromPath } from 'assets/js/utilities/stripPaths';
// import Title from '../../components/TaskModal/Title';
import Title from './components/Title';
// import Actions from '../../components/TaskModal/Actions';
import Actions from './components/Actions';
import ActivityLog from './components/Details/ActivityLog'
// import Details from '../../components/TaskModal/Details';
import Details from './components/Details';
import TM from 'assets/js/classes/TaskModal';
import ModalQrCode from '../QrCode';
import ModalSendEmail from '../SendEmail';
import ModalSendSms from '../SendSms';
import projectsArchived from 'data/projectsArchived'
import useApiCall from 'hooks/useApiCall'
import useWebSocket from 'hooks/useWebSocket'
import ApiChannels from 'assets/js/classes/ApiChannels'
import ApiEvents from 'assets/js/classes/ApiEvents'
import ApiRoutes from 'assets/js/classes/ApiRoutes'
import { AxiosMethods } from 'assets/js/utilities/axios'
import { FormControlProvider } from 'contexts/FormControlContext'
import { updateTenant, useTenantDispatch, useTenantState } from 'contexts/TenantContext'
import eventTaskUpdatedViewModal from 'assets/js/utilities/eventTaskUpdatedViewModal'
import { stateLogin, useAuthDispatch, useAuthState } from 'contexts/AuthContext'

export default function ModalTask({ archive }) {
  // CONTEXT PARAMS - TASK MODAL
  const { task } = useTaskModalState();
  const taskModalDispatch = useTaskModalDispatch();

  // CONTEXT - TENANT
  const { tenant } = useTenantState();

  // CONTEXT - AUTH USER
  const { user } = useAuthState();

  // FORM PARAMS
  const [loading, setLoading] = useState(true);

  // ROUTER DOM PARAMS
  const params = useParams();

  useApiCall({
    apiMethod: AxiosMethods.GET,
    apiRoute: ApiRoutes.TASK(params.taskId),
    callback: ({ task }) => stateUpdateTaskModal(taskModalDispatch, { task }),
    setLoading,
  });

  const taskRef = useRef();
  useEffect(() => { taskRef.current = task }, [task]);

  useWebSocket(ApiChannels.PRIVATE_TENANT(tenant?.id), [
    {
      events: [ApiEvents.TASK_UPDATED],
      callback: ({ author, task }, toastsContext) => eventTaskUpdatedViewModal(
        { author, user, task },
        {
          modal: {
            dataset: taskRef.current,  // https://github.com/facebook/react/issues/14010#issuecomment-433788147
            datasetRef: taskRef,  // https://github.com/facebook/react/issues/14010#issuecomment-433788147
            dispatch: taskModalDispatch,
            prop: 'task',
            update: stateUpdateTaskModal,
          },
        }, { ...toastsContext }
      ),
    },
  ]);

  
  // CLOSE MODAL REDIRECT
  const navigate = useNavigate();
  const handleClose = () => navigate(stripTaskModalFromPath());

  return (
    <>
      <Modal id="ModalTask" show={true} onHide={handleClose} size="lg" keyboard={false}>
        <Modal.Header closeButton className="bg-white align-items-center">
          <Modal.Title className="flex-fill">
            <FormControlProvider>
              <Title task={task} />
            </FormControlProvider>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Row>
            <Col xs={12} lg={8}>
              <Details task={task} />
            </Col>

            <Col xs={12} lg={4}>
              <Actions task={task} />
            </Col>
          </Row>

          <Row>
            <Col>
              <ActivityLog />
            </Col>
          </Row>

        </Modal.Body>
      </Modal>

      <ModalSendEmail task={task} />
      <ModalSendSms task={task} />
      <ModalQrCode task={task} />
    </>
  )
}